export default class LaneHistorySerializer {
  static serialize(data) {
    return {
      ...data,
      orderId: data.id
    };
  }

  static deSerialize(data) {
    return {
      ...data,
      id: data.orderId
    };
  }
}